<script>
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";
import utility from "../../../utility";

export default {
    name: "validity-display",
    components: {VTooltipWrapper},
    props: {
        id: Number | String,
        element: {},
        colorOnlyText: Boolean,
        disableTooltip: Boolean,
        duration: String,
        chip: Boolean,
        noTime: Boolean,
    },
    computed: {
        displayedText() {
            return `${this.duration}, ${this.validity.text}`;
        },
        tooltipReference() {
            return `validity-display-tooltip-${this.id}`;
        },
        tooltipText() {
            const [dateValidity, timeValidity] = this.validity.text.split(',');
            return {
                duration: `${Lang.langGet('Duration')}: ${this.duration}`,
                dateValidity,
                timeValidity,
            }
        },
        /**
         *
         * @returns {{status: String, text: String}}
         */
        validity() {
            const validFrom = this.getDate('valid_from');
            const validTo = this.getDate('valid_to');

            if (this.noTime) return utility.checkValidity(validFrom, validTo);

            const time = {
                From: this.element.valid_time_from ?? {HH: null, mm: null},
                To: this.element.valid_time_to ?? {HH: null, mm: null}
            };

            return utility.checkValidity(validFrom, validTo, time);
        }
    },
    methods: {
        getDate(prop) {
            const value = this.element[prop];
            const placeholder = this.element[`${prop}_placeholder`];

            if (this.element.validityDetached) {
                return value;
            }

            return value ? value : placeholder;
        },
    }
}
</script>

<template>
    <v-chip v-if="chip" :class="`${validity.status} elevation-1`" label small>
        <i class="far fa-calendar mr-2"/>
        {{ validity.text }}
    </v-chip>
    <div v-else :id="tooltipReference" class="validity-display file-name" :class="colorOnlyText ? null : validity.status">
        <i class="fa-regular fa-clock m-r-xs"/>
        <span :class="colorOnlyText ? validity.status : null">{{displayedText}}</span>
        <v-tooltip-wrapper v-if="!disableTooltip" :activator="`#${tooltipReference}`">
            <div class="d-flex flex-column">
                <div class="flex-row">{{tooltipText.duration}}</div>
                <div class="flex-row">{{tooltipText.dateValidity}}</div>
                <div class="flex-row">{{tooltipText.timeValidity}}</div>
            </div>
        </v-tooltip-wrapper>
    </div>
</template>

<style scoped>
    .validity-display {
        cursor: default;
        border-radius: 8px;
    }
</style>
